import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Overview/Index'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/:lang?',
      props: true,
      name: 'Map',
      component: Index,
      beforeEnter: (to, from, next) => {
        if (to.path.toLowerCase() !== to.path) {
          return next(to.path.toLowerCase())
        }
        next()
      }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js